<script setup lang="ts"></script>

<template>
  <footer :class="$style.footer">
    <slot name="logo" />
    <ul :class="$style.footer__links">
      <li>
        <a href="https://400f.jp/" target="_blank" rel="noopener">
          運営企業について
        </a>
      </li>
    </ul>
    <small :class="$style.footer__copyright">
      Copyright © 400F. All rights reserved.
    </small>
  </footer>
</template>

<style lang="scss" module>
.footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 40px 24px;

  &__links {
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-top: 24px;
    font-size: 12px;

    @include mobile-only {
      flex-direction: column;
      align-items: center;
      gap: 4px;
      margin-top: 12px;
    }
  }

  &__copyright {
    margin-top: 12px;
    font-size: 12px;
  }
}
</style>
